module.exports = __webpack_public_path__ + "static/media/fwd.a467c7cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/fwd.svg
// module id = 27
// module chunks = 1